import { Routes } from '@angular/router';
import { AuthGuard, RoleGuard } from './core/guards/auth.guard';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./features/landing/landing.component').then(m => m.LandingComponent)
  },
  {
    path: 'home',
    loadComponent: () => import('./features/home/home.component').then(m => m.HomeComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'fascicoli/crea',
    loadComponent: () => import('./features/fascicoli/fascicolo-create/fascicolo-create.component').then(m => m.FascicoloCreateComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'fascicoli/domande-sostegno',
    loadComponent: () => import('./features/domande-sostegno/domande-sostegno.component').then(m => m.DomandeSostegnoComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'fascicoli/domande-sostegno/controlli-ta',
    loadComponent: () => import('./features/domande-sostegno/controllo-ta-domanda-sostegno-page/controllo-ta-domanda-sostegno-page').then(m => m.ControlloTADomandaSostegnoPageComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'fascicoli/domande-pagamento',
    loadComponent: () => import('./features/domande-pagamento/domande-pagamento.component').then(m => m.DomandePagamentoComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'fascicoli/domande-pagamento/controlli-ta',
    loadComponent: () => import('./features/domande-pagamento/controllo-ta-domanda-pagamento-page/controllo-ta-domanda-pagamento-page').then(m => m.ControlloTADomandaPagamentoPageComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'fascicoli',
    loadComponent: () => import('./features/fascicoli/fascicoli.component').then(m => m.FascicoliComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'controlli-ta',
    loadComponent: () => import('./features/controlli-ta/controlli-ta.component').then(m => m.ControlliTAComponent),
    canActivate: [AuthGuard]
  },

      {
        path: 'utenti',
        loadComponent: () => import('./features/utenti/utenti.component').then(m => m.UtentiComponent),
        canActivate: [AuthGuard, RoleGuard],
        data: { roles: ['SUPER_ADMIN', 'ADMIN', 'RESPONSABILE_FASCICOLO'] }
      },
      {
        path: 'bandi',
        loadComponent: () => import('./features/bandi/bandi.component').then(m => m.BandiComponent),
        canActivate: [AuthGuard]
      },
      {
        path: 'beneficiari',
        loadComponent: () => import('./features/beneficiari/beneficiari.component').then(m => m.BeneficiariComponent),
        canActivate: [AuthGuard]
      },
      {
        path: 'controlli-in-situ',
        loadComponent: () => import('./features/controlli-in-situ/controlli-in-situ.component').then(m => m.ControlliInSituComponent),
        canActivate: [AuthGuard]
      },
      {
        path: 'controlli-in-loco',
        loadComponent: () => import('./features/controlli-in-loco/controlli-in-loco.component').then(m => m.ControlliInLocoComponent),
        canActivate: [AuthGuard]
      },
      {
        path: 'controllori',
        loadComponent: () => import('./features/controllori/controllori.component').then(m => m.ControlloriComponent),
        canActivate: [AuthGuard, RoleGuard],
        data: { roles: ['SUPER_ADMIN', 'ADMIN', 'RESPONSABILE_FASCICOLO'] }
      },
      {
        path: 'istruttori',
        loadComponent: () => import('./features/istruttori/istruttori.component').then(m => m.IstruttoriComponent),
        canActivate: [AuthGuard, RoleGuard],
        data: { roles: ['SUPER_ADMIN', 'ADMIN', 'RESPONSABILE_FASCICOLO'] }
      },
      {
        path: 'documenti',
        loadComponent: () => import('./features/documenti/documenti.component').then(m => m.DocumentiComponent),
        canActivate: [AuthGuard]
      },
      {
        path: 'veci/ico',
        loadComponent: () => import('./features/veci/ico/ico.component').then(m => m.IcoComponent),
        canActivate: [AuthGuard]
      },
      {
        path: 'distanza-apiari',
        loadComponent: () => import('./features/distanza-apiari/distanza-apiari-page.component').then(m => m.DistanzaApiariPageComponent),
        canActivate: [AuthGuard]
      },
      {
        path: 'supporto/faq',
        loadComponent: () => import('./features/supporto/faq/faq.component').then(m => m.FaqComponent),
        canActivate: [AuthGuard]
      },
      {
        path: 'controlli-in-loco/:controlloId',
        loadComponent: () => import('./shared/components/controllo-loco-page/controllo-loco-page').then(m => m.ControlloLocoPageComponent),
        canActivate: [AuthGuard]
      },
      {
        path: 'controlli-in-situ/:controlloId',
        loadComponent: () => import('./shared/components/controllo-situ-page/controllo-situ-page').then(m => m.ControlloSituPageComponent),
        canActivate: [AuthGuard]
      },

  {
    path: '**',
    redirectTo: '',
    pathMatch: 'full'
  }
];
